import { FLOW_STEPS, ImproveFlows } from 'share/types'
import { GetApplicationStatusResponse } from 'share/types/api/main'
import { MANUAL_STATUS_STEP_CHECK_HANDLERS } from 'utils/step-resolvers/status-step-resolvers'

import { pathnames, STEPS_WITH_MANUAL_RESOLUTION } from '../constants'
import { getDamuProgramPaths } from './damu-flow'
import { getDev1FlowPaths } from './dev1-flow'
import { getMainFlowPaths } from './main-flow'
import { getImproveCreditConditionsPaths, getNotaryFlowPaths, getSpouseFlowPaths } from './other-flows'
import { getImprovePledgeFlowPaths, getOwnProgramAutoPaths, getOwnProgramPaths, getPledgeFlowPaths } from './own-flow'
import { getConfirmationThirdPartyPledgePaths, getThirdPartyPledgePaths } from './third-party-pledge-flow'

export const getRouteByStatus = (statusResponse: GetApplicationStatusResponse, improveFlows?: Array<ImproveFlows>) => {
  const {
    current_step,
    credit_program,
    next_step: nextStep,
    credit_status,
    is_colvir_worktime,
    next_step_depends_on_colvir_worktime,
    need_spouse_consent: needSpouseConsent
  } = statusResponse
  if (!current_step) {
    switch (credit_program) {
      case 'OWN_PROGRAM':
        return getOwnProgramPaths(nextStep, needSpouseConsent)
      case 'DAMU':
        return getDamuProgramPaths(nextStep, needSpouseConsent)
    }
  }
  const {
    flow_type: flowType,
    step: currentStep,
    status: currentStepStatus,
    can_retry,
    retry_at,
    flow_status,
    depends_on_colvir_worktime
  } = current_step

  const isRetryAvailableByTime = retry_at > 0
  const isStepRetryable =
    can_retry && !STEPS_WITH_MANUAL_RESOLUTION.includes(currentStep as FLOW_STEPS) && isRetryAvailableByTime
  const isFlowOnHold = flow_status === 'HOLD' && isRetryAvailableByTime
  const isStepDependOnColvir =
    !is_colvir_worktime && (depends_on_colvir_worktime || next_step_depends_on_colvir_worktime)

  const isStepNeedsManualCheck = MANUAL_STATUS_STEP_CHECK_HANDLERS.some(handler => handler(current_step))

  // Проверки на то что кредит выдан
  if (credit_status === 'ISSUED') {
    return pathnames.success
  }

  // Проверка на то что кредит отклонен
  if (currentStep && currentStepStatus === 'REJECTED') {
    return pathnames.rejected
  }

  // Проверки для плохих кейсов
  if (isStepDependOnColvir || (isStepRetryable && !isStepNeedsManualCheck) || isFlowOnHold) {
    return pathnames.retry
  }

  const step = nextStep ? nextStep : currentStep

  if (step === FLOW_STEPS.DECISION && improveFlows?.includes('IMPROVE_CREDIT_CONDITIONS')) {
    if (credit_program === 'DAMU') {
      return pathnames['upgrade-conditions']
    } else if (credit_program === 'OWN_PROGRAM') {
      return pathnames.decision
    }
  }

  switch (flowType) {
    case 'MAIN_FLOW':
      return getMainFlowPaths(step)
    case 'MAIN_FLOW_IBUL':
      return getMainFlowPaths(step)
    case 'DAMU':
      return getDamuProgramPaths(step, needSpouseConsent)
    case 'OWN':
      return getOwnProgramPaths(step, needSpouseConsent)
    case 'OWN_AUTO':
      return getOwnProgramAutoPaths(step, needSpouseConsent)
    case 'IMPROVE_CREDIT_CONDITIONS':
      return getImproveCreditConditionsPaths(statusResponse, step, improveFlows)
    case 'IMPROVE_PLEDGE_CREDIT_CONDITIONS':
      return getImprovePledgeFlowPaths(step)
    case 'COLLATERAL':
      return getPledgeFlowPaths(step, statusResponse.borrower_record.marital_status)
    case 'NOTARY':
      return getNotaryFlowPaths(step)
    case 'CONFIRMATION_SPOUSE':
      return getSpouseFlowPaths(step)
    case 'CONFIRMATION_THIRD_PARTY_PLEDGE':
      return getConfirmationThirdPartyPledgePaths(step)
    case 'THIRD_PARTY_PLEDGE':
      return getThirdPartyPledgePaths(step)
    case 'DEV_1':
      return getDev1FlowPaths(step)
  }
}
